<template>
  <f7-page>
    <f7-navbar :title="groupName" />

    <f7-searchbar
      disable-link-text="Cancel"
      search-container="#search-list"
      search-in=".item-title, .item-text, .item-subtitle"
      placeholder="搜尋餐廳"
      :clear-button="true" />

    <f7-list class="searchbar-not-found">
      <f7-list-item title="沒有結果" />
    </f7-list>

    <f7-list media-list id="search-list">
      <template
        v-for="(menu, index) in storeMenus">
        <f7-list-item
          v-if="menu.variation === 'main'"
          :key="`index-stores-${index}`"
          :title="menu.name"
          :subtitle="menu.branch"
          :text="menu.variationTitle"
          after="點我進入"
          @click="navigateToMenu(menu.storeId, menu.variation)" />
      </template>
    </f7-list>
  </f7-page>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { storeClient } from '@/service/apiClients'

export default {
  data () {
    return {
      groupName: '餐廳群組',
      storeMenus: []
    }
  },
  async created () {
    const { data: storeGroups } = await storeClient.get(`storeGroups/${this.storeGroupIdPathParam}`)

    this.groupName = storeGroups.name

    this.storeMenus = storeGroups.stores.map(s => ({
      storeId: s.id,
      name: s.name,
      branch: s.branch,
      variation: 'main',
      variationTitle: '主要菜單'
    }))
  },
  computed: {
    ...mapState(['menuVariation']),
    ...mapGetters(['storeId'])
  },
  props: {
    storeGroupIdPathParam: String
  },
  methods: {
    ...mapActions(['resetOrderParams']),
    ...mapActions('itemModule', ['resetAllBuckets']),
    ...mapActions('menuModule', ['resetMenus']),
    navigateToMenu (storeId, variation) {
      if (storeId !== this.storeId || variation !== this.menuVariation) {
        this.resetOrderParams()
        this.resetAllBuckets()
        this.resetMenus()
      }

      this.$f7router.navigate(`/stores/${storeId}/${variation === 'main' ? 'menu' : `menus/${variation}`}`)
    }
  }
}
</script>
